import { imagesZoom as ImagesZoom } from "./script/touch-scale-img.js";
import "./style/touch-scale-img.css";

ImagesZoom.init({
  elem: ".para-img"
});